import { useMutation } from '@apollo/client';
import { graphql } from '@app/graphql/types';

export const QUERY = graphql(`
    mutation CancelOnlineOrderReview($onlineOrderID: ID!) {
        storefront_onlineOrder_review_cancel(onlineOrderID: $onlineOrderID)
    }
`);

export function useOnlineOrderReviewCancel() {
  return useMutation(QUERY, {refetchQueries: ['OnlineOrderDetailPage']});
} 